import _classCallCheck from "C:/Users/Mariana Costa/MyProjects/my-personal-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/Mariana Costa/MyProjects/my-personal-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { getRandom, getRangeValue, getStyleFromHsl, rangeColorToHsl } from "tsparticles-engine";
import { Twinkle } from "./Options/Classes/Twinkle";
export var TwinkleUpdater = /*#__PURE__*/function () {
  function TwinkleUpdater() {
    _classCallCheck(this, TwinkleUpdater);
  }
  _createClass(TwinkleUpdater, [{
    key: "getColorStyles",
    value: function getColorStyles(particle, context, radius, opacity) {
      var pOptions = particle.options,
        twinkleOptions = pOptions.twinkle;
      if (!twinkleOptions) {
        return {};
      }
      var twinkle = twinkleOptions.particles,
        twinkling = twinkle.enable && getRandom() < twinkle.frequency,
        zIndexOptions = particle.options.zIndex,
        zOpacityFactor = Math.pow(1 - particle.zIndexFactor, zIndexOptions.opacityRate),
        twinklingOpacity = twinkling ? getRangeValue(twinkle.opacity) * zOpacityFactor : opacity,
        twinkleRgb = rangeColorToHsl(twinkle.color),
        twinkleStyle = twinkleRgb ? getStyleFromHsl(twinkleRgb, twinklingOpacity) : undefined,
        res = {},
        needsTwinkle = twinkling && twinkleStyle;
      res.fill = needsTwinkle ? twinkleStyle : undefined;
      res.stroke = needsTwinkle ? twinkleStyle : undefined;
      return res;
    }
  }, {
    key: "init",
    value: function init() {}
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      var pOptions = particle.options,
        twinkleOptions = pOptions.twinkle;
      if (!twinkleOptions) {
        return false;
      }
      return twinkleOptions.particles.enable;
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(options) {
      if (!options.twinkle) {
        options.twinkle = new Twinkle();
      }
      for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        sources[_key - 1] = arguments[_key];
      }
      for (var _i = 0, _sources = sources; _i < _sources.length; _i++) {
        var source = _sources[_i];
        options.twinkle.load(source === null || source === void 0 ? void 0 : source.twinkle);
      }
    }
  }, {
    key: "update",
    value: function update() {}
  }]);
  return TwinkleUpdater;
}();